import React, { useState } from "react";
import { toast } from "sonner";
import { Link2, Sparkles, Loader2, ExternalLink } from "lucide-react";
import { api } from "../../lib/api";
import { act } from "../../lib/sales";
import { SwipeGallery } from "../common/SwipeGallery";

// Lead photos + shareable listing preview + AI lookup of the business on other platforms.
export function LeadMedia({ p, onChanged }) {
  const r = p.research || {};
  const [plats, setPlats] = useState(r.platforms || null);
  const [busy, setBusy] = useState("");
  async function share() {
    setBusy("share");
    const d = await act(() => api.post(`/admin/vi/prospects/${p.prospect_id}/preview`));
    setBusy("");
    if (d) {
      const url = `${window.location.origin}${d.url}`;
      Promise.resolve(navigator.clipboard?.writeText(url)).then(() => toast.success("Preview link copied — send it to the lead")).catch(() => toast.message(`Preview link: ${url}`));
      onChanged?.();
    }
  }
  async function find() {
    setBusy("ai");
    const d = await act(() => api.post(`/admin/vi/prospects/${p.prospect_id}/ai-platforms`));
    setBusy("");
    if (d) { setPlats(d.platforms); onChanged?.(); }
  }
  const b = "h-9 px-3 rounded-full border border-[var(--line)] text-xs font-semibold inline-flex items-center gap-1.5 hover:border-[var(--gold)] disabled:opacity-50";
  return (
    <div className="px-5 pt-4 space-y-3" data-testid="lp-media">
      {r.photos?.length > 0 ? <SwipeGallery photos={r.photos} height="h-56 md:h-72" testid="lp-gallery" /> : <p className="text-xs text-[#5c544b]" data-testid="lp-no-photos">No photos yet — open “Research &amp; photos” to add Google or website photos.</p>}
      <div className="flex flex-wrap gap-2">
        <button onClick={share} disabled={!!busy} className={b} data-testid="lp-share-preview">{busy === "share" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Link2 className="w-3.5 h-3.5" />}Copy listing preview link</button>
        {p.preview_token && <a href={`/preview/${p.preview_token}`} target="_blank" rel="noreferrer" className={b} data-testid="lp-open-preview"><ExternalLink className="w-3.5 h-3.5" />Open preview{p.preview_views ? ` · ${p.preview_views} views` : ""}</a>}
        <button onClick={find} disabled={!!busy} className={b} data-testid="lp-ai-platforms">{busy === "ai" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />}Find on other platforms (AI)</button>
      </div>
      {plats && <div className="space-y-1" data-testid="lp-platforms">
        {plats.map((x) => <a key={x.url} href={x.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-sm hover:text-[var(--gold)]" data-testid="lp-platform"><ExternalLink className="w-3.5 h-3.5 shrink-0" /><b>{x.platform}</b><span className="truncate text-[#5c544b]">{x.url.replace(/^https:\/\/(www\.)?/, "")}</span><span className="ml-auto shrink-0 text-[11px] px-2 py-0.5 rounded bg-violet-100 text-violet-700">{x.status} · unverified</span></a>)}
        {!plats.length && <p className="text-xs text-[#5c544b]">The AI couldn't find other profiles it was confident about.</p>}
      </div>}
    </div>
  );
}
